class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    
    // Search suggestions - customize these for your store
this.suggestions = [
            '',

      '            tamang dress for ladies',
      '            wanju bhaku',
      '            khenja shirt',
      '            prayer flags',
      '            eight lucky signs',
      '            lepcha shirt',
      '            curtain',
      '            bhutanese dress kira',
      '            tibetan bakhu for ladies',
      '            magar dress set',
      '            tibetan dress for men',
      '            limboo dress',
      '            limbu saree',
      '            monk dress',
      '            daura suruwal for men',
      '            tamang coat for men',
      '            bakhu for kids',
      '            cholo blouse',
      '            rai blouse',
      '            dhaka saree',
      '            necklace',
      '            hairband',
      '            tilhari pote',
      '            rai shawl',
      '            dhaka topi',
      '            tamang topi',
      '            bhadgaunle topi',
      '            lama jhola',
      '            khukri badge',
      '            thangka',
      '            singing bowl',
      '            incense sticks',
      '            incense burner',
      '            electric butter lamp',
      '            bell and dorje',
      '            phurba',
      '            domang pecha',
      '            ting set of 7',
      '            bhumpa',
      '            serkyem',
      '            buddha keychain',
      '            fridge magnet',
      '            dragon kettle',
      '            para sho game',
      '            shamboo',
    ];

    
    this.currentSuggestionIndex = 0;
    this.suggestionInterval = null;
    this.isUserInteracting = false;
    this.originalPlaceholder = '';
    
    if (this.input) {
      // Store original placeholder
      this.originalPlaceholder = this.input.placeholder || 'Search products...';
      
      // Ensure placeholder is visible
      this.ensurePlaceholderVisible();
      
      // Existing event listeners
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      
      // New event listeners for suggestions
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.input.addEventListener('blur', this.onBlur.bind(this));
      
      // Start suggestion rotation
      this.startSuggestionRotation();
    }
  }

  ensurePlaceholderVisible() {
    // Add inline styles to ensure placeholder is visible
    const style = document.createElement('style');
    style.textContent = `
      .search__input::placeholder,
      input[type="search"]::placeholder {
        color: #666 !important;
        opacity: 1 !important;
        font-style: italic;
      }
      .search__input::-webkit-input-placeholder,
      input[type="search"]::-webkit-input-placeholder {
        color: #666 !important;
        opacity: 1 !important;
        font-style: italic;
      }
      .search__input::-moz-placeholder,
      input[type="search"]::-moz-placeholder {
        color: #666 !important;
        opacity: 1 !important;
        font-style: italic;
      }
      .search__input:-ms-input-placeholder,
      input[type="search"]:-ms-input-placeholder {
        color: #666 !important;
        opacity: 1 !important;
        font-style: italic;
      }
    `;
    
    // Only add the style once
    if (!document.querySelector('#search-suggestions-style')) {
      style.id = 'search-suggestions-style';
      document.head.appendChild(style);
    }
    
    // Force placeholder to be visible
    this.input.style.setProperty('--placeholder-opacity', '1', 'important');
  }

  startSuggestionRotation() {
    this.stopSuggestionRotation();
    
    if (!this.input.value && !this.isUserInteracting) {
      setTimeout(() => {
        if (!this.input.value && !this.isUserInteracting) {
          this.rotateSuggestion();
          this.suggestionInterval = setInterval(() => {
            if (!this.input.value && !this.isUserInteracting) {
              this.rotateSuggestion();
            } else {
              this.stopSuggestionRotation();
            }
          }, 2000); // Change every 3 seconds
        }
      }, 2000); // Wait 2 seconds before starting
    }
  }

  stopSuggestionRotation() {
    if (this.suggestionInterval) {
      clearInterval(this.suggestionInterval);
      this.suggestionInterval = null;
    }
  }

  rotateSuggestion() {
    this.currentSuggestionIndex = (this.currentSuggestionIndex + 1) % this.suggestions.length;
    this.input.placeholder = this.suggestions[this.currentSuggestionIndex];
  }

  onFocus() {
    this.isUserInteracting = true;
    this.stopSuggestionRotation();
    this.input.placeholder = this.originalPlaceholder;
  }

  onBlur() {
    this.isUserInteracting = false;
    
    if (!this.input.value) {
      setTimeout(() => {
        if (!this.input.value && !this.isUserInteracting) {
          this.startSuggestionRotation();
        }
      }, 1000);
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
    
    if (this.input.value.length > 0) {
      this.stopSuggestionRotation();
    } else {
      setTimeout(() => {
        if (!this.input.value && !this.isUserInteracting) {
          this.startSuggestionRotation();
        }
      }, 1500);
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
      
      setTimeout(() => {
        if (!this.input.value && !this.isUserInteracting) {
          this.startSuggestionRotation();
        }
      }, 1000);
    }
  }

  // Method to update suggestions
  updateSuggestions(newSuggestions) {
    this.suggestions = newSuggestions;
    this.currentSuggestionIndex = 0;
    
    if (!this.input.value && !this.isUserInteracting) {
      this.stopSuggestionRotation();
      this.startSuggestionRotation();
    }
  }
}

customElements.define('search-form', SearchForm);